import {APP_PREFIX_PATH} from '@/constants/route.constant'
import {NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE,} from '@/constants/navigation.constant'
import {Permissions} from "@/constants/app.constant";

const financialNavigationConfig = [
    {
        key: 'financial',
        path: '',
        title: 'مالی',
        translateKey: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.financial.value],
        subMenu: [
            {
                key: 'orders',
                path: `${APP_PREFIX_PATH}/orders`,
                title: 'سفارشات',
                translateKey: 'سفارشات',
                icon: 'PiPackageFill',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.financial.orders.value],
                subMenu: [],
            },
        ]
    }
]

export default financialNavigationConfig
